export function hoverNewsWorks() {
    let newsroomItem = $(".newsroom .item");
    let newsroomLink = newsroomItem.find("figure a, h3 a, .h3 a, .button");
    let colectionDetails = $(".collection-detail a");
    newsroomLink.hover(function () {
        $(this).parents(".item").find("figure a, h3 a, .h3 a, .button").addClass("hover");
    }, function () {
        $(this).parents(".item").find("figure a, h3 a, .h3 a, .button").removeClass("hover");
    });
    colectionDetails.hover(function () {
        $(this).parents(".collection-detail-box").find("a").addClass("hover");
    }, function () {
        $(this).parents(".collection-detail-box").find("a").removeClass("hover");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/hoverNewsWorks.js